<template>
  <div
    class="write-comment"
    :class="isH5 ? 'h5-write-comment' : 'pc-write-comment'"
  >
    <Header v-if="!isHXApp" title="写评价" />
    <div class="page-cont">
      <!-- 课程信息 -->
      <div class="course-info">
        <img
          class="cover"
          :src="courseInfo.cover_url + '?imageView2/0/w/300'"
          alt=""
        />
        <p class="title">
          {{ courseInfo.course_name }}
        </p>
      </div>
      <!-- 评价内容 -->
      <div class="comment-cont">
        <p class="score-item">
          <span class="title total-score">整体评价</span
          ><Star
            @result="handleTotalResult"
            :disabled="false"
            :score="scores.star"
            key="total-score"
          />
        </p>
        <ul v-if="scores.star" class="subScore">
          <li v-for="item in subScore" :key="item.name" class="score-item">
            <span class="title">{{ item.title }}</span
            ><Star
              :disabled="false"
              :score="scores[item.name]"
              :key="item.name"
              @result="
                (val) => {
                  handleSubResult(val, item.name);
                }
              "
            />
          </li>
        </ul>

        <div class="content-wrap">
          <ul class="tag-list">
            <li
              @click="handleTagChouse(item.id)"
              :class="{ 'is-active': tag.includes(item.id) }"
              v-for="item in tagList"
              :key="item.id"
            >
              {{ item.name }}
            </li>
          </ul>
          <el-input
            type="textarea"
            placeholder="可以从学习收获、内容质量、老师授课表现和课程服务等角度进行评价~"
            v-model="comment"
            maxlength="500"
            show-word-limit
            :autosize="{ minRows: 7, maxRows: 10 }"
            resize="none"
          >
          </el-input>

          <!-- 图片上传 -->
          <UploadImages
            class="upload-wrap"
            v-model="comment_img"
            :sts-api="'/v1/cos/updateCourseCommonImg'"
            :sts-params="uploadParams"
            :limit="6"
            :data-type="'object'"
          />
        </div>
      </div>

      <div v-if="isH5" class="h5-anonymity">
        <el-checkbox v-model="anonymity"></el-checkbox>匿名评价
      </div>

      <div class="fixed-footer">
        <div class="anonymity">
          <el-checkbox v-model="anonymity"></el-checkbox><span>匿名评价</span>
        </div>
        <button
          @click="handleSubmit"
          class="primary-btn"
          v-preventReClick
          :disabled="submiting"
        >
          提交评价
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { TAGLIST } from "@saas/components/src/constants/comment";
import { getCourseInfo } from "@saas/server-api/src/product-details";
import { saveComment, getCommentInfo } from "@saas/server-api/src/comment";
import { Header, isHXApp, isH5, Star, UploadImages } from "@saas/components";
export default {
  data: function () {
    return {
      type: "add",
      submiting: false,
      course_id: "",
      comment_id: "", //评论id
      courseInfo: {},
      isHXApp: isHXApp(),
      isH5: isH5(),
      scores: {
        star: 0,
        content_star: 0,
        aura_star: 0,
        teacher_star: 0,
      },
      tag: [],
      comment: "",
      comment_img: [],
      anonymity: false,
      subScore: [
        {
          name: "content_star",
          title: "课程内容",
        },
        {
          name: "aura_star",
          title: "课堂氛围",
        },
        {
          name: "teacher_star",
          title: "老师风采",
        },
      ],
      tagList: TAGLIST,
      firstRate: true, //首次评分
    };
  },
  created() {
    let { course_id, comment_id } = this.$route.params;
    this.course_id = course_id;
    this.comment_id = comment_id;
    if (course_id) {
      this.type = "add";
      this.apiGetCourseInfo();
    } else if (comment_id) {
      this.type = "edit";
      this.firstRate = false;
      //回显数据
      this.apiGetCommentInfo();
    }
  },
  methods: {
    apiGetCommentInfo() {
      let params = {
        id: this.comment_id,
      };
      getCommentInfo(params).then((res) => {
        if (res.code === 1) {
          let {
            course_name,
            cover_url,
            star,
            content_star,
            aura_star,
            teacher_star,
            tag,
            comment,
            comment_img,
            anonymity,
            course_id,
          } = res.data || {};
          this.courseInfo = { course_name, cover_url };
          this.scores = {
            star,
            content_star,
            aura_star,
            teacher_star,
          };
          this.tag = tag || [];
          this.comment = comment;
          if (comment_img?.length && comment_img[0]) {
            this.comment_img = comment_img.map((item) => {
              if (item.startsWith("https") || item.startsWith("http")) {
                return {
                  url: item,
                };
              } else {
                return {
                  url: `https:${item}`,
                };
              }
            });
          }

          this.anonymity = anonymity === 1;
          this.course_id = course_id;
        } else if (res.code === 1111) {
          this.$chiralAutoMessage(`该评价已删除或不存在`, 1200);
          setTimeout(() => {
            this.$router.push({
              name: "CommentList",
            });
          }, 1200);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCourseInfo() {
      getCourseInfo({ course_id: this.course_id }).then((res) => {
        const { code, data = {}, message } = res;
        if (code === 1) {
          this.courseInfo = data || {};
        } else {
          this.$message.error(message);
        }
      });
    },
    handleSubResult(val, name) {
      this.scores[name] = val;
    },
    handleSubmit() {
      if (!this.scores.star) {
        this.$showToast("请对该课程进行整体评价评分~");
        return;
      } else if (
        this.scores.star < 4 &&
        this.comment.trim().replace(/[\r\n]/g, "").length < 15
      ) {
        this.$showToast("请说明该课程让您不满意的原因，至少15字，期待您的反馈");
        return;
      }
      if (this.type === "edit") {
        this.$confirm(
          "每个评价仅可修改一次，是否提交此次修改后的评价？",
          "提示",
          {
            center: true,
            cancelButtonText: "取消",
            confirmButtonText: "确认",
            customClass: "saas-confirm-message",
            confirmButtonClass: "confirm-btn",
            cancelButtonClass: "cancel-btn",
            closeOnClickModal: false,
          }
        )
          .then(() => {
            this.apiSaveComment();
          })
          .catch(() => {});
      } else {
        this.apiSaveComment();
      }
    },
    apiSaveComment() {
      let params = {
        ...this.scores,
        tag: this.tag,
        comment: this.comment,
        anonymity: this.anonymity ? 1 : 2,
        course_id: this.course_id,
      };
      if (this.comment_img?.length) {
        let arr = this.comment_img.map((item) => {
          return item.url;
        });
        params.comment_img = arr;
      }
      if (this.comment_id) {
        params.id = Number(this.comment_id);
      }

      if (this.submiting) return false;
      this.submiting = true;
      saveComment(params).then((res) => {
        if (res.code === 1) {
          this.$router.push({
            name: "CommentComplete",
            params: {
              comment_id: res.data.id,
            },
          });
        } else {
          this.$message.error(res.message);
        }
        this.submiting = false;
      });
    },
    handleTagChouse(id) {
      if (this.tag.includes(id)) {
        this.tag = this.tag.filter((item) => {
          return item !== id;
        });
      } else {
        this.tag.push(id);
      }
    },
    handleTotalResult(val) {
      if (this.firstRate) {
        this.firstRate = false;
        for (const key in this.scores) {
          if (Object.prototype.hasOwnProperty.call(this.scores, key)) {
            this.scores[key] = val;
          }
        }
      } else {
        this.scores.star = val;
      }
    },
  },
  computed: {
    uploadParams() {
      return {};
    },
  },
  components: {
    Header,
    Star,
    UploadImages,
  },
};
</script>

<style lang="scss" scoped>
.pc-write-comment {
  background-color: #f7f8f9;
  min-height: 100vh;
  padding-bottom: 120px;

  .page-cont {
    max-width: 800px;
    margin: 0 auto;
    padding-top: 20px;
  }

  .course-info {
    height: 102px;
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    display: flex;
    align-items: center;
    padding: 12px;
    margin-bottom: 12px;
    .cover {
      width: 140px;
      height: 78px;
      margin-right: 12px;
      border-radius: 14px;
      object-fit: cover;
    }
    .title {
      flex: 1;
      width: 0;
      font-weight: 500;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
  .comment-cont {
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    padding: 12px 16px 16px;
  }

  .score-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .title {
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      margin-right: 12px;
    }
    .total-score.title {
      font-weight: 600;
    }
  }

  .tag-list {
    margin-top: 6px;
    display: flex;
    li {
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 28px;
      width: 88px;
      height: 30px;
      border-radius: 15px;
      border: 1px solid #e4e4e4;
      margin-right: 9px;
      margin-bottom: 16px;
      text-align: center;
      cursor: pointer;
    }
    li:last-child {
      margin-right: 0px;
    }
    .is-active {
      border: none;
      background: rgba(0, 200, 157, 0.08);
      color: #00c89d;
      line-height: 30px;
    }
  }
  ::v-deep .el-textarea {
    margin-bottom: 12px;
    .el-textarea__inner {
      background: #f7f8f9;
      border-radius: 16px;
      border: none;
      padding: 16px;
      height: 160px;
      font-weight: 400;
      font-size: 18px;
      color: #0d1400;
      line-height: 25px;
      &::placeholder {
        font-size: 18px;
        color: #747573;
      }
    }
    .el-input__count {
      font-size: 12px;
      color: #747573;
      bottom: 8px;
      right: 13px;
      background: #f7f8f9;
    }
  }

  .fixed-footer {
    z-index: 2;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    width: 800px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px -6px 16px 0px rgba(102, 116, 107, 0.1);
    border-radius: 24px 24px 0px 0px;
    .primary-btn {
      width: 160px;
      height: 50px;
      border-radius: 12px;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
    }
    .anonymity {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #515350;
    }
  }
}
.h5-write-comment {
  background-color: #f7f8f9;
  min-height: 100vh;
  padding-bottom: 3rem;
  .page-cont {
    padding: 0.13rem 0 0;
  }

  .course-info {
    height: 2.19rem;
    background: #ffffff;
    border-radius: 0.32rem;
    display: flex;
    align-items: center;
    padding: 0 0.32rem;
    margin: 0 0.32rem 0.27rem;
    .cover {
      width: 2.81rem;
      height: 1.58rem;
      border-radius: 0.13rem;
      margin-right: 0.15rem;
      object-fit: cover;
    }
    .title {
      flex: 1;
      width: 0;
      font-weight: 600;
      font-size: 0.37rem;
      color: #0d1400;
      line-height: 0.53rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }

  .comment-cont {
    margin: 0 0.32rem 0;
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0.27rem 0 0 0;
  }

  .score-item {
    padding: 0 0.32rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.27rem;
    .title {
      font-weight: 400;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      margin-right: 0.27rem;
    }
    .total-score.title {
      font-weight: 600;
    }
  }

  .content-wrap {
    padding: 0 0.32rem 0.1rem 0.32rem;
  }

  .tag-list {
    border-top: 1px solid #efefef;
    padding: 0.32rem 0 0;
    display: flex;
    flex-wrap: wrap;
    li {
      font-weight: 400;
      font-size: 0.37rem;
      color: #0d1400;
      line-height: 0.69rem;
      width: 2.03rem;
      height: 0.72rem;
      border-radius: 0.35rem;
      border: 0.02rem solid #e4e4e4;
      margin-right: 0.2rem;
      margin-bottom: 0.21rem;
      text-align: center;
    }
    li:nth-child(4n) {
      margin-right: 0px;
    }
    .is-active {
      border: none;
      background: rgba(0, 200, 157, 0.08);
      color: #00c89d;
      line-height: 0.72rem;
    }
  }

  ::v-deep .el-textarea {
    margin: 0.4rem 0 0.35rem;
    .el-textarea__inner {
      background: #f7f8f9;
      border-radius: 0.32rem;
      border: none;
      padding: 0.32rem;
      height: 3.2rem;
      font-weight: 400;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      &::placeholder {
        font-size: 0.4rem;
        color: #747573;
      }
    }
    .el-input__count {
      font-size: 12px;
      color: #747573;
      bottom: 8px;
      right: 13px;
      background: #f7f8f9;
    }
  }

  .h5-anonymity {
    margin-top: 0.4rem;
    margin-left: 0.45rem;
    font-size: 0.37rem;
    color: #515350;
    .el-checkbox .el-checkbox__inner {
      border-radius: 0.08rem;
      margin-right: 0.21rem;
    }
  }

  .fixed-footer {
    z-index: 2;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 2.4rem;
    background: #ffffff;
    box-shadow: 0rem -0.16rem 0.43rem 0rem rgba(102, 116, 107, 0.1);
    border-radius: 0.64rem 0.64rem 0rem 0rem;
    .primary-btn {
      width: 9.36rem;
      height: 1.33rem;
      border-radius: 0.32rem;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      font-weight: 600;
      font-size: 0.43rem;
      color: #ffffff;
      line-height: 1.33rem;
      text-align: center;
    }
    .anonymity {
      display: none;
    }
  }
}
</style>
